import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowSecondaryTopRightIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M12.1621 3.95164C12.0415 3.83102 11.8741 3.75737 11.6898 3.75737L6.357 3.75737C5.98883 3.7569 5.6904 4.05533 5.6904 4.42396L5.6904 4.50499C5.68993 4.87315 5.98836 5.17158 6.357 5.17158L9.99934 5.17158L3.83793 11.333C3.57772 11.5932 3.57772 12.0156 3.83793 12.2758C4.09815 12.536 4.52053 12.536 4.78074 12.2758L10.9421 6.11439L10.9421 9.75673C10.9417 10.1249 11.2401 10.4233 11.6087 10.4233L11.6898 10.4233C12.0579 10.4238 12.3564 10.1254 12.3564 9.75673L12.3564 4.42396C12.3566 4.23988 12.2827 4.07226 12.1621 3.95164Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowSecondaryTopRightIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowSecondaryTopRightIcon;
